// extracted by mini-css-extract-plugin
export default {"labelTokenBase":"LabelToken-module__labelTokenBase--v0rBi","labelTokenDeleteButton":"LabelToken-module__labelTokenDeleteButton--VLMDp"};